import { loadJsonFromUrl } from "./util/json-loader";

export interface Video {
  videoId: string;
  title: string;
  publishedAt: Date;
  thumbnailUrl: string;
}

interface RawVideo {
  videoId: string;
  title: string;
  publishedAt: string;
  thumbnailUrl: string;
}

const VIDEOS_JSON_URL =
  "https://assets.richmondwoodturners.org/videos/videos.json";

async function getRecentVideos(maxVideos: number): Promise<Video[] | null> {
  const rawVideos = await loadJsonFromUrl<RawVideo[]>(VIDEOS_JSON_URL);
  if (rawVideos === null) {
    console.error(
      `Failed to load videos from ${VIDEOS_JSON_URL}. Returning null.`,
    );
    return null;
  }

  return rawVideos
    .map(parseVideo)
    .sort((a, b) => b.publishedAt.getTime() - a.publishedAt.getTime())
    .slice(0, maxVideos);
}

function parseVideo(video: RawVideo): Video {
  return {
    ...video,
    publishedAt: new Date(video.publishedAt),
  };
}

export async function getLatestVideo(): Promise<Video | null> {
  const videos = await getRecentVideos(1);
  return videos && videos.length > 0 ? videos[0] : null;
}

export function populateYouTubeVideos(
  querySelector: string,
  count: number,
): void {
  getRecentVideos(count).then((videos) => {
    if (videos === null) {
      populateErrorYouTubeVideos(querySelector);
      return;
    }

    const container = document.querySelector<HTMLElement>(querySelector);
    if (!container) return;

    container.innerHTML = videos
      .map(
        (video) => `
          <a class="video" href="https://www.youtube.com/watch?v=${video.videoId}" target="_blank" rel="noreferrer noopener">
            <img src="${video.thumbnailUrl}" alt="${video.title}" loading="lazy">
            <p>${video.title}</p>
          </a>
        `,
      )
      .join("");

    if (container.classList.contains("expand-in")) {
      container.classList.add("visible");
    }
  });
}

function populateErrorYouTubeVideos(querySelector: string): void {
  const container = document.querySelector<HTMLElement>(querySelector);
  if (!container) return;

  container.innerHTML = "<p>Failed to load videos. Try again later.</p>";
}
